import { Col, Form, Select } from "antd";
import {
  IMPORT_B2B_LC_LIST,
  SALES_CONTRACT_LIST,
} from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

const B2BLCAcceptanceCommissionFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [b2bLcs, setB2bLcs] = useState([]);
  const [salesContracts, setSalesContracts] = useState([]);
  const [loadingB2BLc, setLoadingB2BLc] = useState(false);
  const [loadingSalesContract, setLoadingSalesContract] = useState(false);

  // Get B2B LCs
  const getB2BLCs = async (filter) => {
    setLoadingB2BLc(true);
    const body = {
      page: 1,
      per_page: 50,
      ...(filter?.b2b_lc_number && { b2b_lc_number: filter.b2b_lc_number }),
    };
    const response = await getData(IMPORT_B2B_LC_LIST, null, body);
    if (response?.status === 200) {
      setB2bLcs(response?.data?.data?.data || []);
    }
    setLoadingB2BLc(false);
  };

  // Get Sales Contracts
  const getSalesContracts = async (filter) => {
    setLoadingSalesContract(true);
    const body = {
      page: 1,
      per_page: 50,
      ...(filter?.reference_no && { reference_no: filter.reference_no }),
    };
    const response = await getData(SALES_CONTRACT_LIST, null, body);
    if (response?.status === 200) {
      setSalesContracts(response?.data?.data?.data || []);
    }
    setLoadingSalesContract(false);
  };

  // On search B2B LCs
  const onB2BLcSearch = useCallback(async (value) => {
    if (value && value.length >= 2) {
      await getB2BLCs({ b2b_lc_number: value });
    } else if (!value) {
      await getB2BLCs();
    }
  }, []);

  // On search Sales Contracts
  const onSalesContractSearch = useCallback(async (value) => {
    if (value && value.length >= 2) {
      await getSalesContracts({ reference_no: value });
    } else if (!value) {
      await getSalesContracts();
    }
  }, []);

  useEffect(() => {
    getB2BLCs();
    getSalesContracts();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item label="B2B LC Number" name="b2b_lc_number">
          <Select
            size="small"
            placeholder="Select B2B LC Number"
            loading={loadingB2BLc}
            showSearch
            optionFilterProp="children"
            onSearch={onB2BLcSearch}
            allowClear
          >
            {b2bLcs.map((lc) => (
              <Option key={lc.b2b_lc_id || lc.id} value={lc.id}>
                {lc.b2b_lc_number}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      {/* <Col span={4}>
        <Form.Item label="Sales Contract Number" name="sales_contract_number">
          <Select
            size="small"
            placeholder="Select Sales Contract"
            loading={loadingSalesContract}
            showSearch
            optionFilterProp="children"
            onSearch={onSalesContractSearch}
            allowClear
          >
            {salesContracts.map((contract) => (
              <Option key={contract.id} value={contract.id}>
                {contract.reference_no}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col> */}
    </>
  );
};

export default B2BLCAcceptanceCommissionFilterFields;
